"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertPastedContentFromExcel_1 = require("./excelConverter/convertPastedContentFromExcel");
var convertPastedContentFromWord_1 = require("./wordConverter/convertPastedContentFromWord");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var constants_1 = require("./officeOnlineConverter/constants");
var convertPastedContentFromWordOnline_1 = require("./officeOnlineConverter/convertPastedContentFromWordOnline");
var WORD_ATTRIBUTE_NAME = 'xmlns:w';
var WORD_ATTRIBUTE_VALUE = 'urn:schemas-microsoft-com:office:word';
var EXCEL_ATTRIBUTE_NAME = 'xmlns:x';
var EXCEL_ATTRIBUTE_VALUE = 'urn:schemas-microsoft-com:office:excel';
var EXCEL_ONLINE_ATTRIBUTE_NAME = 'ProgId';
var EXCEL_ONLINE_ATTRIBUTE_VALUE = 'Excel.Sheet';
var GOOGLE_SHEET_NODE_NAME = 'google-sheets-html-origin';
/**
 * Paste plugin, handles BeforePaste event and reformat some special content, including:
 * 1. Content copied from Word
 * 2. Content copied from Excel
 * 3. Content copied from Word Online or Onenote Online
 */
var Paste = /** @class */ (function () {
    /**
     * Create an instance of Paste
     * @param preserved @deprecated Not used. Preserved parameter only used for compatibility with old code
     * @param attributeCallbacks @deprecated A set of callbacks to help handle html attribute during sanitization
     */
    function Paste(preserved, attributeCallbacks) {
        this.attributeCallbacks = attributeCallbacks;
    }
    /**
     * Get a friendly name of  this plugin
     */
    Paste.prototype.getName = function () {
        return 'Paste';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    Paste.prototype.initialize = function (editor) {
        this.editor = editor;
    };
    /**
     * Dispose this plugin
     */
    Paste.prototype.dispose = function () {
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    Paste.prototype.onPluginEvent = function (event) {
        var _this = this;
        if (event.eventType == 9 /* BeforePaste */) {
            var htmlAttributes = event.htmlAttributes, fragment = event.fragment, sanitizingOption_1 = event.sanitizingOption;
            var wacListElements = void 0;
            if (htmlAttributes[WORD_ATTRIBUTE_NAME] == WORD_ATTRIBUTE_VALUE) {
                // Handle HTML copied from Word
                convertPastedContentFromWord_1.default(event);
            }
            else if (htmlAttributes[EXCEL_ATTRIBUTE_NAME] == EXCEL_ATTRIBUTE_VALUE ||
                htmlAttributes[EXCEL_ONLINE_ATTRIBUTE_NAME] == EXCEL_ONLINE_ATTRIBUTE_VALUE) {
                // Handle HTML copied from Excel
                convertPastedContentFromExcel_1.default(event);
            }
            else if ((wacListElements = fragment.querySelectorAll(constants_1.WAC_IDENTIFING_SELECTOR))[0]) {
                // Once it is known that the document is from WAC
                // We need to remove the display property and margin from all the list item
                wacListElements.forEach(function (el) {
                    el.style.display = null;
                    el.style.margin = null;
                });
                // call conversion function if the pasted content is from word online and
                // has list element in the pasted content.
                if (convertPastedContentFromWordOnline_1.isWordOnlineWithList(fragment)) {
                    convertPastedContentFromWordOnline_1.default(fragment);
                }
            }
            else if (fragment.querySelector(GOOGLE_SHEET_NODE_NAME)) {
                sanitizingOption_1.additionalAllowedTags.push(GOOGLE_SHEET_NODE_NAME);
            }
            // TODO: Deprecate attributeCallbacks parameter
            if (this.attributeCallbacks) {
                Object.keys(this.attributeCallbacks).forEach(function (name) {
                    roosterjs_editor_dom_1.chainSanitizerCallback(sanitizingOption_1.attributeCallbacks, name, _this.attributeCallbacks[name]);
                });
            }
        }
    };
    /**
     * @deprecated
     * Paste into editor using passed in clipboardData with original format
     * @param clipboardData The clipboardData to paste
     */
    Paste.prototype.pasteOriginal = function (clipboardData) {
        this.editor.paste(clipboardData);
    };
    /**
     * @deprecated
     * Paste plain text into editor using passed in clipboardData
     * @param clipboardData The clipboardData to paste
     */
    Paste.prototype.pasteText = function (clipboardData) {
        this.editor.paste(clipboardData, true /*pasteAsText*/);
    };
    /**
     * @deprecated
     * Paste into editor using passed in clipboardData with curent format
     * @param clipboardData The clipboardData to paste
     */
    Paste.prototype.pasteAndMergeFormat = function (clipboardData) {
        this.editor.paste(clipboardData, false /*pasteAsText*/, true /*applyCurrentFormat*/);
    };
    return Paste;
}());
exports.default = Paste;
//# sourceMappingURL=Paste.js.map